<template>
  <div>
    <BaseHeader>
      <template v-slot:title>Terms and Conditions</template>
    </BaseHeader>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { BaseHeader } from '@/components/base'

export default defineComponent({
  name: 'TermsAndConditions',
  title: 'Terms and Conditions',
  components: {
    BaseHeader
  }
})
</script>
